// stores/useFooterStore.ts
import { create } from 'zustand'

interface FooterState {
  showFullFooter: boolean
  setShowFullFooter: (footer: boolean) => void
}

const useFooterStore = create<FooterState>((set) => ({
  showFullFooter: true,
  setShowFullFooter: (footer) => set({ showFullFooter: footer }),
}))

export default useFooterStore;
